import React from 'react'

import styles from '../sidebar.module.scss'
import SidebarFooterMenu from './FooterMenu'

const SidebarFooter = ({ user }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)

  return (
    <div className={styles.sidebarFooter}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.footerWrapper}
        onClick={() => {
          if (!isMenuOpen) {
            setIsMenuOpen(true)
          }
        }}
      >
        <div className={styles.footerLogo}>
          <div className={styles.logoWrapper}>
            {user.avatar ? (
              <img src={user.avatar} alt={user.name} />
            ) : (
              <span>{user.name.charAt(0)}</span>
            )}
          </div>
        </div>
        <div className={styles.footerCompanyName}>
          <h3>{user.name}</h3>
          <p>
            Balance{' '}
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(user.balance / 100)}
          </p>
        </div>
        <div className={styles.footerSettingsIcon}>
          <button>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8766 12.882C18.9136 12.594 18.9414 12.306 18.9414 12C18.9414 11.694 18.9136 11.406 18.8766 11.118L20.8289 9.633C21.0047 9.498 21.051 9.255 20.9399 9.057L19.0894 5.943C19.0062 5.799 18.8489 5.718 18.6823 5.718C18.6268 5.718 18.5713 5.727 18.525 5.745L16.2212 6.645C15.74 6.285 15.2219 5.988 14.6575 5.763L14.3059 3.378C14.2782 3.162 14.0839 3 13.8525 3H10.1515C9.92024 3 9.72593 3.162 9.69818 3.378L9.34658 5.763C8.78218 5.988 8.26404 6.294 7.78291 6.645L5.47905 5.745C5.42353 5.727 5.36802 5.718 5.3125 5.718C5.15521 5.718 4.99792 5.799 4.91464 5.943L3.06415 9.057C2.94387 9.255 2.99938 9.498 3.17518 9.633L5.12745 11.118C5.09044 11.406 5.06268 11.703 5.06268 12C5.06268 12.297 5.09044 12.594 5.12745 12.882L3.17518 14.367C2.99938 14.502 2.95312 14.745 3.06415 14.943L4.91464 18.057C4.99792 18.201 5.15521 18.282 5.32175 18.282C5.37727 18.282 5.43278 18.273 5.47905 18.255L7.78291 17.355C8.26404 17.715 8.78218 18.012 9.34658 18.237L9.69818 20.622C9.72593 20.838 9.92024 21 10.1515 21H13.8525C14.0839 21 14.2782 20.838 14.3059 20.622L14.6575 18.237C15.2219 18.012 15.74 17.706 16.2212 17.355L18.525 18.255C18.5806 18.273 18.6361 18.282 18.6916 18.282C18.8489 18.282 19.0062 18.201 19.0894 18.057L20.9399 14.943C21.051 14.745 21.0047 14.502 20.8289 14.367L18.8766 12.882ZM17.0909 12C17.0909 11.811 17.0817 11.622 17.0446 11.343L16.9151 10.326L17.7386 9.696L18.7286 8.931L18.0809 7.842L16.9059 8.301L15.9251 8.688L15.0831 8.058C14.713 7.788 14.3429 7.581 13.9451 7.419L12.9643 7.032L12.8163 6.015L12.6405 4.8H11.3544L11.1693 6.015L11.0213 7.032L10.0405 7.419C9.66117 7.572 9.28181 7.788 8.88396 8.076L8.05123 8.688L7.08898 8.31L5.91391 7.851L5.26624 8.94L6.26551 9.696L7.08898 10.326L6.95944 11.343C6.93168 11.613 6.91318 11.82 6.91318 12C6.91318 12.18 6.93168 12.387 6.95944 12.666L7.08898 13.683L6.26551 14.313L5.26624 15.069L5.91391 16.158L7.08898 15.699L8.06974 15.312L8.91172 15.942C9.28181 16.212 9.65191 16.419 10.0498 16.581L11.0305 16.968L11.1786 17.985L11.3544 19.2H12.6497L12.8348 17.985L12.9828 16.968L13.9636 16.581C14.3429 16.428 14.7223 16.212 15.1201 15.924L15.9529 15.312L16.9151 15.69L18.0902 16.149L18.7378 15.06L17.7386 14.304L16.9151 13.674L17.0446 12.657C17.0724 12.387 17.0909 12.189 17.0909 12Z"
                fill="#B3B3B3"
              />
              <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                fill="#B3B3B3"
              />
            </svg>
          </button>
        </div>
      </div>
      <SidebarFooterMenu
        user={user}
        setVisibility={setIsMenuOpen}
        visible={isMenuOpen}
      />
    </div>
  )
}

export default SidebarFooter
